module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-system-bar', {
    staticClass: "overline",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n    Your appointment\n  ")]), _vm._v(" "), (_vm.appointment && _vm.appointment.id) ? [(_vm.isRecurring) ? [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Recurring appointment created\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              First appointment: " + _vm._s(_vm.formatFromTo(_vm.appointment.start_time, _vm.appointment.end_time)) + "\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(_vm.appointment.num_recurrances) + " appointments recurring " + _vm._s(_vm.appointment.recurrance_rate.toLowerCase()) + "\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("reset")
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("\n          Add another")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)] : [(_vm.appointment && _vm.appointment.id) ? _c('small-appointment-card', {
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      }
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  }, [_c('template', {
    slot: "card-actions"
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("reset")
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("\n              Add another")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 2) : _vm._e()]] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a91ea2b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/actions/After.vue
// module id = 1345
// module chunks = 9